import React from "react";
import {
  ActivityIndicator,
  type ActivityIndicatorProps,
  type StyleProp,
  StyleSheet,
  type ViewStyle,
} from "react-native";

import { palette } from "../styles";
import Block from "./Block";

type Props = ActivityIndicatorProps & {
  backgroundColor?: string;
  color?: string;
  type?: "absolute";
  containerStyles?: StyleProp<ViewStyle>;
};

const Loader = ({
  backgroundColor = palette.common.white,
  color = palette.primary.accent,
  size = "large",
  type,
  containerStyles,
  ...rest
}: Props) => {
  const isAbsolute = type === "absolute";

  return (
    <Block
      style={[styles.loader, containerStyles, { position: isAbsolute ? "absolute" : "fixed" }]}
      height={10}
    >
      <Block
        borderRadius={2}
        padding={backgroundColor ? 2 : 0}
        style={{ ...styles.container, backgroundColor }}
        width={8.25}
        height={8.25}
      >
        <ActivityIndicator color={color} size={size} {...rest} />
      </Block>
    </Block>
  );
};

export default React.memo(Loader);

const styles = StyleSheet.create({
  container: {
    boxShadow: "0px 4px 40px -5px rgba(0, 0, 0, 0.3)",
  },
  loader: {
    bottom: "auto",
    left: "50%",
    right: "auto",
    top: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 10,
  },
});
